import { useTranslation } from 'react-i18next';
import Icon from '../Icon';

function CustomNoRowsOverlay() {
  const { t } = useTranslation('icp-components');
  return (
    <div className="icp-custom-no-rows-overlay icp-center">
      <div className="icp-center">
        <Icon name="oct:inbox" size={48} />
      </div>
      <div>{t('table.no-rows-label')}</div>
    </div>
  );
}

export default CustomNoRowsOverlay;
